var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ReactMouseEvent = /** @class */ (function () {
    function ReactMouseEvent(event) {
        this.event = event;
    }
    ReactMouseEvent.prototype.stopPropagation = function () {
        this.event.stopPropagation();
        //this.event.nativeEvent.stopPropagation();
        //this.event.nativeEvent.stopImmediatePropagation();
    };
    ReactMouseEvent.prototype.preventDefault = function () {
        this.event.preventDefault();
        //this.event.nativeEvent.preventDefault();
    };
    Object.defineProperty(ReactMouseEvent.prototype, "cancelBubble", {
        get: function () {
            //return this.event.cancelBubble;
            return false;
        },
        set: function (value) {
            //this.event.cancelBubble = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactMouseEvent.prototype, "target", {
        get: function () {
            return this.event.target;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactMouseEvent.prototype, "currentTarget", {
        get: function () {
            return this.event.currentTarget;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactMouseEvent.prototype, "clientX", {
        get: function () {
            return this.event.clientX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactMouseEvent.prototype, "clientY", {
        get: function () {
            return this.event.clientY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactMouseEvent.prototype, "offsetX", {
        get: function () {
            return this.event.nativeEvent.offsetX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactMouseEvent.prototype, "offsetY", {
        get: function () {
            return this.event.nativeEvent.offsetY;
        },
        enumerable: false,
        configurable: true
    });
    return ReactMouseEvent;
}());
export { ReactMouseEvent };
var ReactDragEvent = /** @class */ (function (_super) {
    __extends(ReactDragEvent, _super);
    function ReactDragEvent(event) {
        var _this = _super.call(this, event) || this;
        _this.event = event;
        return _this;
    }
    Object.defineProperty(ReactDragEvent.prototype, "dataTransfer", {
        get: function () {
            return this.event.dataTransfer;
        },
        enumerable: false,
        configurable: true
    });
    return ReactDragEvent;
}(ReactMouseEvent));
export { ReactDragEvent };
